export default {
  title: 'Internet Bajo Demanda',
  error: 'Servicio no disponible por el momento. Intente de nuevo más tarde.',
  modal_button: 'Finalizar',
  internet_on: {
    switch: 'Encendido',
    subtitle: 'Si apagas el internet bajo demanda, solo podrás navegar si tienes un paquete activo',
    modal: {
      title: 'Activación exitosa',
      description:
        'Haz encendido el internet bajo demanda, al terminar tu paquete podrás seguir navegando utilizando tu saldo.',
      extended_description:
        'Recuerda que al finalizar tu saldo, debes recargar o adquirir un nuevo SuperPack para continuar navegando.'
    }
  },
  internet_off: {
    switch: 'Apagado',
    subtitle:
      'Si enciendes el internet bajo demanda, al terminar tu paquete podrás seguir navegando utilizando tu saldo.',
    modal: {
      title: 'Desactivación exitosa',
      description:
        'Haz apagado el internet bajo demanda, te recordamos que sólo podrás navegar si tienes un paquete activo.',
      extended_description:
        'Al finalizar tu paquete, adquiere tu SuperPack favorito para continuar navegando.'
    }
  },
  wifi: {
    title: 'Estimado Usuario',
    description: 'Desactiva tu WiFi y activa tus datos para acceder a internet bajo demanda.',
    afirmation: 'Recuerda que la navegación en este portal no consume datos.',
    button: 'Salir'
  }
}
